import { render, staticRenderFns } from "./Opportunity.vue?vue&type=template&id=6889bac5&scoped=true"
import script from "./Opportunity.vue?vue&type=script&lang=js"
export * from "./Opportunity.vue?vue&type=script&lang=js"
import style0 from "./Opportunity.vue?vue&type=style&index=0&id=6889bac5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6889bac5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6889bac5')) {
      api.createRecord('6889bac5', component.options)
    } else {
      api.reload('6889bac5', component.options)
    }
    module.hot.accept("./Opportunity.vue?vue&type=template&id=6889bac5&scoped=true", function () {
      api.rerender('6889bac5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/Post/Card/Opportunity.vue"
export default component.exports